import React from 'react';
import { DriverFormData } from '../../types/driver';

interface BankingStepProps {
  data: DriverFormData;
  updateData: (data: Partial<DriverFormData>) => void;
}

const BankingStep: React.FC<BankingStepProps> = ({ data, updateData }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateData({ [name]: value });
  };

  const banks = [
    'Access Bank',
    'First Bank',
    'Guaranty Trust Bank',
    'Zenith Bank',
    'United Bank for Africa',
    'Stanbic IBTC Bank',
    'First City Monument Bank',
    'Union Bank',
    'Sterling Bank',
    'Ecobank Nigeria',
    'Wema Bank',
    'Polaris Bank',
    'Fidelity Bank',
    'Heritage Bank',
    'Keystone Bank',
    'Standard Chartered Bank',
    'Citibank Nigeria',
    'Other'
  ];

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Banking Information</h2>
      <p className="text-gray-600 mb-6">
        Provide your bank account details for receiving payments. This information is secure and encrypted.
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Bank Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Bank Name *
          </label>
          <select
            name="bankName"
            value={data.bankName}
            onChange={(e) => updateData({ bankName: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            required
          >
            <option value="">Select your bank</option>
            {banks.map(bank => (
              <option key={bank} value={bank}>
                {bank}
              </option>
            ))}
          </select>
        </div>

        {/* Account Number */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Account Number *
          </label>
          <input
            type="text"
            name="accountNumber"
            value={data.accountNumber}
            onChange={handleChange}
            maxLength={10}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            required
          />
          <p className="text-xs text-gray-500 mt-1">10-digit account number</p>
        </div>

        {/* Account Name */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Account Name *
          </label>
          <input
            type="text"
            name="accountName"
            value={data.accountName}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            required
          />
          <p className="text-xs text-gray-500 mt-1">Name as it appears on your bank account</p>
        </div>
      </div>

      {/* Security Notice */}
      <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">
              Secure Banking Information
            </h3>
            <div className="mt-2 text-sm text-blue-700">
              <p>
                Your banking information is encrypted and secure. We use bank-level security 
                to protect your financial data.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankingStep;